[
  {
    "id": 32,
    "documentId": "vm40iezt0q76ewbk44uuydzk",
    "name": "Android Developer Expert",
    "slug": "android-developer-expert",
    "issuer": "Dicoding Indonesia",
    "level": "expert",
    "issueDate": "2023-12-01",
    "expiryDate": null,
    "credentialId": "98XW2VD20PM3",
    "description": "Advanced Android development certification covering modern Android development practices, architecture patterns, and best practices.",
    "summary": "Expert-level Android development certification",
    "isFeatured": false,
    "createdAt": "2025-08-05T12:23:58.397Z",
    "updatedAt": "2025-08-05T12:23:58.397Z",
    "publishedAt": "2025-08-05T12:23:58.402Z",
    "categories": [
      {
        "id": 384,
        "name": "mobile-development"
      }
    ],
    "skills": [],
    "education": [],
    "logo": null,
    "certificate": null,
    "badge": null,
    "links": [
      {
        "id": 338,
        "label": "View Certificate",
        "url": "https://www.dicoding.com/certificates/98XW2VD20PM3",
        "type": "certification",
        "showIcon": true,
        "isExternal": true,
        "description": "Android Developer Expert certification",
        "isVisible": null
      }
    ],
    "seo": null
  },
  {
    "id": 34,
    "documentId": "ssm0xguylxt62sqxhipqqcgm",
    "name": "Cloud Practitioner Essentials",
    "slug": "cloud-practitioner-essentials",
    "issuer": "Dicoding Indonesia",
    "level": "foundational",
    "issueDate": "2023-10-01",
    "expiryDate": null,
    "credentialId": "81P27JEG8ZOY",
    "description": "Cloud computing fundamentals and AWS services overview.",
    "summary": "Cloud computing fundamentals certification",
    "isFeatured": false,
    "createdAt": "2025-08-05T12:23:58.422Z",
    "updatedAt": "2025-08-05T12:23:58.422Z",
    "publishedAt": "2025-08-05T12:23:58.425Z",
    "categories": [
      {
        "id": 386,
        "name": "cloud-platforms"
      }
    ],
    "skills": [],
    "education": [],
    "logo": null,
    "certificate": null,
    "badge": null,
    "links": [
      {
        "id": 340,
        "label": "View Certificate",
        "url": "https://www.dicoding.com/certificates/81P27JEG8ZOY",
        "type": "certification",
        "showIcon": true,
        "isExternal": true,
        "description": "Cloud Practitioner Essentials certification",
        "isVisible": null
      }
    ],
    "seo": null
  },
  {
    "id": 36,
    "documentId": "md9ys9wgtiqaieezigaplzwb",
    "name": "Flutter Developer Expert",
    "slug": "flutter-developer-expert",
    "issuer": "Dicoding Indonesia",
    "level": "expert",
    "issueDate": "2023-03-01",
    "expiryDate": null,
    "credentialId": "L4PQ6N1G7PO1",
    "description": "Expert-level Flutter development certification covering advanced Flutter concepts, state management, and app architecture.",
    "summary": "Expert-level Flutter development certification",
    "isFeatured": false,
    "createdAt": "2025-08-05T12:23:58.443Z",
    "updatedAt": "2025-08-05T12:23:58.443Z",
    "publishedAt": "2025-08-05T12:23:58.449Z",
    "categories": [
      {
        "id": 388,
        "name": "mobile-development"
      }
    ],
    "skills": [],
    "education": [],
    "logo": null,
    "certificate": null,
    "badge": null,
    "links": [
      {
        "id": 342,
        "label": "View Certificate",
        "url": "https://www.dicoding.com/certificates/L4PQ6N1G7PO1",
        "type": "certification",
        "showIcon": true,
        "isExternal": true,
        "description": "Flutter Developer Expert certification",
        "isVisible": null
      }
    ],
    "seo": null
  }
]
